import * as React from 'react';
import css from './gradient.module.css';
export function GradientBlock({
  width = '100%',
  height = '16px',
  margin = '0',
}: {
  width?: string;
  height?: string;
  margin?: string;
}) {
  return (
    <span
      className={css.gradientBlock}
      style={{
        width,
        height,
        margin,
      }}
    />
  );
}
export default GradientBlock;
